"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getSessionUser = exports.getSessionCompany = exports.getLocale = exports.getIsSupportAdmin = exports.getIsPreviewing = exports.getIsBillingContact = exports.getIsAccountOwner = exports.getDefaultCurrencySymbol = exports.getCurrencyConfiguration = exports.getCurrency = exports.getCSRF = exports.getAssumedUser = exports.fetchData = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));
var _ajax = _interopRequireDefault(require("../ajax"));
/**
 * This file provides a global data service for fetching various types of data from the server.
 * It utilizes a caching mechanism to store responses and avoid redundant network requests.
 * The service includes functions to fetch session user data, session company data, assumed user data,
 * locale data, currency configuration data, currency data, default currency symbol data, billing contact data,
 * support admin data, account owner data, previewing data, and CSRF data.
 * 
 * Each function returns a promise that resolves to the respective data type.
 * 
 * Example usage:
 * 
 * ```typescript
 * // Fetch session user data
 * getSessionUser().then(sessionUserData => {
 *     console.log(sessionUserData);
 * }).catch(error => {
 *     console.error('Error fetching session user data:', error);
 * });
 * 
 * // Fetch currency data
 * getCurrency().then(currencyData => {
 *     console.log(currencyData);
 * }).catch(error => {
 *     console.error('Error fetching currency data:', error);
 * });
 * 
 * // Fetch CSRF data
 * getCSRF().then(csrfData => {
 *     console.log(csrfData);
 * }).catch(error => {
 *     console.error('Error fetching CSRF data:', error);
 * });
 * ```
 */

const globalDataServiceCache = window.globalDataServiceCache || {};
window.globalDataServiceCache = globalDataServiceCache;
const ajaxRequest = url => () => {
  if (globalDataServiceCache[url] !== undefined) {
    return globalDataServiceCache[url];
  }
  const responsePromise = _ajax.default.get(url).then(response => {
    if (response.status !== 200 && response.statusText !== 'OK') {
      throw new Error(`Request failed with status ${response.status}`);
    }
    return response.data;
  }).catch(error => {
    return _promise.default.reject(error);
  });
  globalDataServiceCache[url] = responsePromise;
  return responsePromise;
};
const ajaxRequestCreator = url => ajaxRequest(url);

/**
 * Fetches the session user data from the server.
 *
 * @returns {Promise<SessionUserData>} A promise that resolves to the session user data.
 */
const getSessionUser = exports.getSessionUser = ajaxRequestCreator('/globals/sessionUser');

/**
 * Fetches the session company data from the server.
 *
 * @returns {Promise<SessionCompanyData>} A promise that resolves to the session company data.
 */
const getSessionCompany = exports.getSessionCompany = ajaxRequestCreator('/globals/sessionCompany');

/**
 * Fetches the assumed user data from the server.
 *
 * @returns {Promise<AssumedUserData>} A promise that resolves to the assumed user data.
 */
const getAssumedUser = exports.getAssumedUser = ajaxRequestCreator('/globals/assumedUser');

/**
 * Fetches the locale data from the server.
 *
 * @returns {Promise<LocaleData>} A promise that resolves to the locale data.
 */
const getLocale = exports.getLocale = ajaxRequestCreator('/globals/locale');

/**
 * Fetches the currency configuration data from the server.
 *
 * @returns {Promise<CurrencyConfigurationData>} A promise that resolves to the currency configuration data.
 */
const getCurrencyConfiguration = exports.getCurrencyConfiguration = ajaxRequestCreator('/globals/currencyConfiguration');

/**
 * Fetches the currency data from the server.
 *
 * @returns {Promise<CurrencyData>} A promise that resolves to the currency data.
 */
const getCurrency = exports.getCurrency = ajaxRequestCreator('/globals/currency');

/**
 * Fetches the default currency symbol data from the server.
 *
 * @returns {Promise<DefaultCurrencySymbolData>} A promise that resolves to the default currency symbol data.
 */
const getDefaultCurrencySymbol = exports.getDefaultCurrencySymbol = ajaxRequestCreator('/globals/defaultCurrencySymbol');

/**
 * Fetches the billing contact data from the server.
 *
 * @returns {Promise<BillingContactData>} A promise that resolves to the billing contact data.
 */
const getIsBillingContact = exports.getIsBillingContact = ajaxRequestCreator('/globals/isBillingContact');

/**
 * Fetches the support admin data from the server.
 *
 * @returns {Promise<SupportAdminData>} A promise that resolves to the support admin data.
 */
const getIsSupportAdmin = exports.getIsSupportAdmin = ajaxRequestCreator('/globals/isSupportAdmin');

/**
 * Fetches the account owner data from the server.
 *
 * @returns {Promise<AccountOnwnerData>} A promise that resolves to the account owner data.
 */
const getIsAccountOwner = exports.getIsAccountOwner = ajaxRequestCreator('/globals/isAccountOwner');

/**
 * Fetches the previewing data from the server.
 *
 * @returns {Promise<PreviewingData>} A promise that resolves to the previewing data.
 */
const getIsPreviewing = exports.getIsPreviewing = ajaxRequestCreator('/globals/isPreviewing');

/**
 * Fetches the CSRF data from the server.
 *
 * @returns {Promise<CSRFData>} A promise that resolves to the CSRF data.
 */
const getCSRF = exports.getCSRF = ajaxRequestCreator('/globals/CSRF');

/**
 * Fetches data from the server for a given endpoint.
 *
 * @param {string} endpoint - The endpoint to fetch data from.
 * @returns {Promise<T>} A promise that resolves to the data from the endpoint.
 */
const fetchData = endpoint => ajaxRequestCreator(endpoint);
exports.fetchData = fetchData;